import React, { useEffect, useState, useRef } from 'react'
import './wizard.css'
// * Helpers
import Notifications, { ERROR_NOTIFICATION, SUCCESS_NOTIFICATION } from '../../helpers/notifications';
import { useTranslation } from 'react-i18next';
import API, { PUBLIC } from "../../services/api";
// Dialogs
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
// Spreadsheet control
import { Spreadsheet } from "@progress/kendo-spreadsheet-react-wrapper";
// Import axios
import { VIEW } from '../../assets/Constants/actionsTypes';

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { ImArrowRight, ImArrowLeft } from 'react-icons/im';

import { Loader } from "@progress/kendo-react-indicators";

const Step7 = (props) => {
    const { t } = useTranslation('common');
    //handle rows and columns sizes
    const [spreadDim, setSpreadDim] = useState({ rows: 1, columns: 1 });
    //ref to the spread
    const spread = useRef(null);
    // if we need change the dimension of rows or columns of the spread, we need no show the spread, so that it reload
    const [showSpread, setShowSpread] = useState(false);
    // Controls wheather the confirmation dialog is shown
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);


    const toggleConfirmationDialog = () => {
        setShowConfirmationDialog(!showConfirmationDialog);
    }

    // * This function is called when the PREVIOUS arrow is clicked.
    // * It is passed as parameter to each step 
    const onPreviousClick = () => {
        props.changeStep(7);
    }

    // * This function is called when the NEXT arrow is clicked.
    // * It is passed as parameter to each step 
    const onNextClick = () => {
        props.changeStep(9);
    }

    useEffect(() => {
        async function getData() {
            try {
                console.log("getData");
                setShowSpread(false);
                // * Find the template in the public folder
                const response = await PUBLIC.get("/step7_templateII.json");
                const data = response.data;
                //update rows and columns for the spread
                setSpreadDim({
                    rows: data.rows.length,
                    columns: data.rows[0].cells.length,
                });
                //we show the spread
                setShowSpread(true);
                // sets the data in the SP
                fillSpreadSheet(data);
            } catch (e) {
                Notifications.notify(String(e), ERROR_NOTIFICATION);
                console.log(e)
            }
        }
        getData()

    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        validate_edit()
    }, [props.isEditMode]);// eslint-disable-line react-hooks/exhaustive-deps

    // Fills the spreadsheet with the data
    const fillSpreadSheet = async (data) => {
        //if the spread is visible we load the data
        //if (showSpread) {
        // Data
        const responseAvailable = await API.get(`/model/step7MatrixData?modelId=${props.modelData.modelid}`);
        // First: Builds the spreadsheet with the template information


        let sheet = spread.current ? spread.current.widgetInstance.activeSheet() : null;
        if (sheet === null) {
            return;
        }
        sheet.frozenRows(1);
        sheet.frozenRows(2);

        sheet.fromJSON(data);
        // Second: Sets the data in the spreadsheet (according to the currnt matrix)
        if (responseAvailable.data.data !== null) {
            // * Sets INATPOP data in the spreadSheet
            let getFemData_INATPOP = responseAvailable.data.data.femaleDataINATPOP.split(";");
            let getMaleData_INATPOP = responseAvailable.data.data.maleDataINATPOP.split(";");
            sheet.range("B3:B103").values(newArray(getMaleData_INATPOP));
            sheet.range("C3:C103").values(newArray(getFemData_INATPOP));
            // * Sets ILF data in the spreadSheet
            let getFemData_ILF = responseAvailable.data.data.femaleDataILF.split(";");
            let getMaleData_ILF = responseAvailable.data.data.maleDataILF.split(";");
            sheet.range("D3:D103").values(newArray(getMaleData_ILF));
            sheet.range("E3:E103").values(newArray(getFemData_ILF));
        }
        validate_edit();


        //}
    }

    const validate_edit = () => {
        // If the wizard is in VIEW mode, the Spreadsheet cannot be edited
        let sheet = spread.current ? spread.current.widgetInstance.activeSheet() : null;
        if (sheet === null) {
            return;
        }
        if (!props.isEditMode) {

            sheet.range("B3:B103").enable(false);
            sheet.range("C3:C103").enable(false);
            sheet.range("D3:D103").enable(false);
            sheet.range("E3:E103").enable(false);
        } else {
            sheet.range("B3:B103").enable(true);
            sheet.range("C3:C103").enable(true);
            sheet.range("D3:D103").enable(true);
            sheet.range("E3:E103").enable(true);
        }
    }



    // * Each value in the array becomes an array. This is because the spreadsheet is filled in rows.
    // Ex: arr = ["50","3","150","2"] => arr = [["50"],["3"],["150"],["2"]] 
    const newArray = (arr) => {
        const result = arr.map((e, i) => {
            const value = parseFloat(e);
            if (isNaN(value)
            ) {
                return [0];
            }
            return [value];
        });
        return result
    }


    // * In the matrixData variable, the values entered for Females and Males are concatenated as a string.
    // * Separated by ; to assemble the data when it is to be displayed
    const saveMatrixData = async () => {
        try {
            // spreadsheet instance
            let actSheet = spread.current.widgetInstance.activeSheet();

            // Splits for validations
            let fem_inatpop_validation = actSheet.range("B3:B103").values();
            let male_inatpop_validation = actSheet.range("C3:C103").values();
            let fem_ilf_validation = actSheet.range("D3:D103").values();
            let male_ilf_validation = actSheet.range("E3:E103").values();

            // Validation that blocks the SAVE if NON-numeric values were entered.
            if (!checkSPData(fem_inatpop_validation) || !checkSPData(male_inatpop_validation) ||
                !checkSPData(fem_ilf_validation) || !checkSPData(male_ilf_validation)) {
                Notifications.notify(t('model.spWrongData'), ERROR_NOTIFICATION);
                return;
            }

            // * INATPOP DATA
            // Data from INATPOP-female row as string
            let male_nat_pop_Vals = actSheet.range("B3:B103").values().toString();
            // Data from INATPOP-male row as string
            let female_nat_pop_Vals = actSheet.range("C3:C103").values().toString();
            // INATPOP-Female value with ; as separator
            let semiFem_inatpop = female_nat_pop_Vals.replaceAll(',', ';');
            // INATPOP-Male value with ; as separator
            let semiMale_inatpop = male_nat_pop_Vals.replaceAll(',', ';');
            // * ILF DATA
            // Data from INATPOP-female row as string
            let male_ilf_Vals = actSheet.range("D3:D103").values().toString();
            // Data from INATPOP-male row as string
            let female_ilf_Vals = actSheet.range("E3:E103").values().toString();
            // INATPOP-Female value with ; as separator
            let semiFem_ilf = female_ilf_Vals.replaceAll(',', ';');
            // INATPOP-Male value with ; as separator
            let semiMale_ilf = male_ilf_Vals.replaceAll(',', ';');

            // object to be sent via API
            let dataSent = {
                modelid: props.modelData.modelid,
                femaleDataINATPOP: semiFem_inatpop,
                maleDataINATPOP: semiMale_inatpop,
                femaleDataILF: semiFem_ilf,
                maleDataILF: semiMale_ilf
            }

            // * call the api to sent the data
            const res = await API.post('/model/step7InsertMatrixData', dataSent);
            // * if errors exist, it is displayed as a notification
            if (res.data.code !== 100) {
                Notifications.notify(res.data.msg, ERROR_NOTIFICATION);
            } else {
                Notifications.notify(t('model.matrixDataInserted'), SUCCESS_NOTIFICATION);
            }


        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }

    }

    const btnReset_onClick = () => {
        toggleConfirmationDialog();
    }

    const onResetMatrixData = async () => {
        try {
            console.log("ToDo: Reset data");
            const responseAvailable = await API.get(`/model/step7ResetMatrixData?modelId=${props.modelData.modelid}`);
            let sheet = spread.current ? spread.current.widgetInstance.activeSheet() : null;
            if (sheet === null) {
                return;
            }
            // Sets the data in the spreadsheet (according to the currnt matrix)
            if (responseAvailable.data.data !== null) {
                // * Sets INATPOP data in the spreadSheet
                let getFemData_INATPOP = responseAvailable.data.data.femaleDataINATPOP.split(";");
                let getMaleData_INATPOP = responseAvailable.data.data.maleDataINATPOP.split(";");
                sheet.range("B3:B103").values(newArray(getMaleData_INATPOP));
                sheet.range("C3:C103").values(newArray(getFemData_INATPOP));
                // * Sets ILF data in the spreadSheet
                let getFemData_ILF = responseAvailable.data.data.femaleDataILF.split(";");
                let getMaleData_ILF = responseAvailable.data.data.maleDataILF.split(";");
                sheet.range("D3:D103").values(newArray(getMaleData_ILF));
                sheet.range("E3:E103").values(newArray(getFemData_ILF));
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    // Checks if the array has string values
    // If it has string values, the function returns FALSE that means the SP its wrong
    const checkSPData = (arr) => {
        let result = arr.every(function (e) {
            return typeof e[0] === 'number';
        });
        return result;
    }

    // Export the current spreadsheet data to excel
    const handleExport = () => {

        try {
            const spreadInstance = spread.current.widgetInstance;
            if (spreadInstance === null) {
                return;
            }
            spreadInstance.saveAsExcel();
        } catch (error) {
            Notifications.notify(String(error), ERROR_NOTIFICATION);
            console.log(error)
        }
    }

    return (
        <div className="col-md-12">
            <div className="row">
                <h6>{t('model.step7_desc')}</h6>
            </div>
            <div className="row row_attrs container_steps">
                <div className="col-md-10" >
                    {showSpread ? (
                        <>
                            <button
                                className="btn btn-primary ilo-btn"
                                style={{ marginBottom: "10px", marginRight: "3px" }}
                                onClick={handleExport}>
                                {t('model.excelExport_btn')}
                            </button>

                            {props.isEditMode ? (
                                <>
                                    <button
                                        onClick={() => { saveMatrixData(); }}
                                        className="btn btn-primary ilo-btn"
                                        style={{ marginBottom: "10px", marginRight: "3px" }}
                                    >
                                        {t('model.step7_save_btn')}
                                    </button>

                                    <button
                                        onClick={btnReset_onClick}
                                        className="btn btn-primary ilo-btn"
                                        style={{ marginBottom: "10px", marginRight: "3px" }}
                                    >
                                        {t('model.step7_reset_btn')}
                                    </button>
                                </>
                            ) : null
                            }

                            {/*El nombre de excel es el nombre del modelo + MatrixBySex*/}
                            <Spreadsheet
                                columns={spreadDim.columns}
                                rows={spreadDim.rows}
                                ref={spread}
                                className="test"
                                excelExport={(e) => {
                                    e.workbook.fileName = `${props.modelData.name ? 'MatrixBySex_' + props.modelData.name : 'MatrixBySex_Step7'}.xlsx`;
                                }}
                            ></Spreadsheet>

                        </>
                    ) : <Loader size="large" type="converging-spinner" />}
                </div>
            </div>
            <div className="row arrows_position">
                <div className="col-sm-12">
                    <button className="btn_style" type="button" onClick={() => { onPreviousClick(); }} ><ImArrowLeft /></button>
                    {props.isActionView === VIEW ? null : !props.isEditMode ? (
                        <button
                            onClick={() => { props.editSteps(); }}
                            className="btn btn-primary ilo-btn"
                            style={{ marginBottom: "10px", marginRight: "3px" }}
                        >
                            {t('model.step7_edit_btn')}
                        </button>
                    ) : null
                    }
                    <button className="btn_style" type="button" onClick={() => { onNextClick(); }} ><ImArrowRight /></button>
                </div>
            </div>

            {showConfirmationDialog &&
                <Dialog
                    className="ilo-delete-confirm"
                    title={t('model.step7_confirmation_reset_title')}
                    onClose={() => toggleConfirmationDialog()}
                >
                    <p style={{ margin: "25px", textAlign: "center" }}>{t('model.step7_confirmation_reset_msg')}</p>
                    <DialogActionsBar layout="end">
                        <button className="k-button" onClick={onResetMatrixData}>{t('alerts.yes_btn')}</button>
                        <button className="k-button" onClick={toggleConfirmationDialog}>{t('alerts.no_btn')}</button>
                    </DialogActionsBar>
                </Dialog>
            }
        </div>
    );
}

export default Step7